export default function CycleIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Repeating cycle icon" data-testid="cycle-icon">
      {/* octagonal progression path — echoes the Blueprint for Success shape */}
      <polygon
        points="54.2,22.8 41.2,9.8 22.8,9.8 9.8,22.8 9.8,41.2 22.8,54.2 41.2,54.2 54.2,41.2"
        fill="none"
        stroke="#222F5B"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      {/* clockwise arrowheads — navy, white halo punches through the path */}
      <g fill="#222F5B" stroke="#FFFFFF" strokeWidth="2.5" strokeLinejoin="round">
        <path d="M27 3.95 L40 9.8 L27 15.65 Z" />
        <path d="M48.35 26.5 L60.05 26.5 L54.2 38.85 Z" />
        <path d="M37 48.35 L24 54.2 L37 60.05 Z" />
        <path d="M15.65 37.5 L3.95 37.5 L9.8 25.15 Z" />
      </g>
    </svg>
  );
}
